import { useEffect } from "react";
import Pusher from "pusher-js";

const useChatPusher = (conversationId, onMessageReceived) => {
  useEffect(() => {
    const pusher = new Pusher("YOUR_PUSHER_KEY", {
      cluster: "YOUR_CLUSTER",
      authEndpoint: "/api/broadcasting/auth",
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    });

    const channel = pusher.subscribe(`private-chat.${conversationId}`);

    channel.bind("MessageSent", (data) => {
      onMessageReceived(data.message);
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [conversationId, onMessageReceived]);
};

export default useChatPusher;
